import React from 'react'
import { connect, useDispatch } from 'react-redux';
import Alert from '../../../../../../../itrust_common/components/Alert';
import RPAVerifyButton from '../../eligibilityVerify/RPAVerifyButton';
import { visionInsuranceDetailView, visionInsuranceEligibilityEdit } from '../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction';

function CecVerify(props) {
  const { pprops, pprops: { insuranceType, handleInsuranceVerifySubmit, setShowVerifyBtn, selectedInsuranceMemberId } } = props
  const dispatch = useDispatch()

  const handleVerifyInsurance = () => {
    handleInsuranceVerifySubmit({ member_id: selectedInsuranceMemberId })
  }

  const handleReVerifyInsurance = () => {
    Alert.confirm('Are you sure you want to Re-Verify Insurance.', res => {
      if (res) {
        dispatch(visionInsuranceDetailView({ visible: false }))
        setShowVerifyBtn(true)
        dispatch(visionInsuranceEligibilityEdit({ [insuranceType]: null }))
        handleVerifyInsurance()
      }
    })
  }

  return (
    <RPAVerifyButton
      pprops={pprops}
      handleVerifyInsurance={handleVerifyInsurance}
      handleReVerifyInsurance={handleReVerifyInsurance}
    />
  )
}

export default connect()(CecVerify)
